import { PaymentMethodService } from '@wix/cashier-core/dist/src/services/PaymentMethod';
import { IPaymentMethodsListRequestParams } from '@wix/cashier-core/dist/src/services/PaymentMethod/types';
import { appInstanceResolver } from '../appInstanceResolver';

const paymentMethodService = () =>
  new PaymentMethodService({
    appInstance: appInstanceResolver.appInstance,
    revalidateAppInstance: appInstanceResolver.revalidate,
  });

export const ERROR_FETCH_METHODS_LIST = 'ERROR_FETCH_METHODS_LIST';
export const paymentMethodAPI = {
  fetchPaymentMethods: (params: IPaymentMethodsListRequestParams) => {
    return paymentMethodService()
      .fetchPaymentMethods(params)
      .catch(() => {
        throw new Error(ERROR_FETCH_METHODS_LIST);
      });
  },
};
